export const setPagePath = (slug: string) => `/${slug}/`;
